import { ref } from "vue";
import { tryOnUnmounted } from "@vueuse/core";

import * as Api from "@/api";
import { useStore } from "@/use/useStore";

export function useTokens() {
  let botTokenTimer: number | undefined = undefined;
  let authTokenTimer: number | undefined = undefined;

  tryOnUnmounted(() => {
    clearInterval(botTokenTimer);
    clearInterval(authTokenTimer);
  });

  const { currentUser } = useStore();

  const botToken = ref<BotToken>({ value: "", timeout: 0 });
  const authToken = ref<AuthToken>({ value: "", timeout: 0 });
  const entrantScore = ref<EntrantScore>({
    id: "",
    default_entrant_password: true,
    entrant_password: "",
  });

  async function fetchBotToken() {
    clearInterval(botTokenTimer);

    const { data } = await Api.fetchBotToken(currentUser.value!.id);

    botToken.value = {
      value: data.value,
      timeout: Math.floor(data.timeout / 1000),
    };

    botTokenTimer = setInterval(() => {
      botToken.value.timeout--;
      botToken.value.timeout <= 0 && fetchBotToken();
    }, 1000);
  }

  async function fetchAuthToken() {
    clearInterval(authTokenTimer);

    const { data } = await Api.fetchLkToken(currentUser.value!.id);

    authToken.value = {
      value: data.value,
      timeout: Math.floor(data.timeout / 1000),
    };

    authTokenTimer = setInterval(() => {
      authToken.value.timeout--;
      authToken.value.timeout <= 0 && fetchAuthToken();
    }, 1000);
  }

  async function fetchEntrantScore() {
    const { data } = await Api.fetchEntrantScore(currentUser.value!.id);
    entrantScore.value = data;
  }

  return {
    botToken,
    fetchBotToken,

    authToken,
    fetchAuthToken,

    entrantScore,
    fetchEntrantScore,
  };
}
